import React from 'react';

import { TFunction } from '@lyearn/i18n';
import { StatusPill, Typography } from '@lyearn/ui';
import {
  ContentApprovalStatusEnum,
  KnowledgeAssetContentType,
  ResourceStatusEnum,
} from '@/types/schema';

export const renderKnowledgeAssetStatusPill = (entity: KnowledgeAssetContentType, t: TFunction) => {
  if (entity.approvalStatus === ContentApprovalStatusEnum.InReview) {
    return (
      <StatusPill
        appearance="warning"
        className="max-w-[8.8rem]"
        label={<Typography variant="label-caps">{t('Common:ContentStatus.Pending')}</Typography>}
        size="medium"
        variant="light"
      />
    );
  }

  if (entity.approvalStatus === ContentApprovalStatusEnum.Rejected) {
    return (
      <StatusPill
        appearance="danger"
        className="max-w-[8.8rem]"
        label={<Typography variant="label-caps">{t('Common:ContentStatus.Rejected')}</Typography>}
        size="medium"
        variant="light"
      />
    );
  }

  if (entity.status === ResourceStatusEnum.UnpublishedChanges) {
    return (
      <StatusPill
        appearance="purple"
        className="max-w-[20rem]"
        label={
          <Typography variant="label-caps">
            {t('Common:ContentStatus.UnpublishedChanges')}
          </Typography>
        }
        size="medium"
        variant="light"
      />
    );
  }

  if (entity.status === ResourceStatusEnum.Draft) {
    return (
      <StatusPill
        appearance="primary"
        className="max-w-[8.8rem]"
        label={<Typography variant="label-caps">{t('Common:ContentStatus.Draft')}</Typography>}
        size="medium"
        variant="light"
      />
    );
  }

  return null;
};
